import type { FormResponseValue } from "@tellescope/types-models";

/**
 * The answers a patient may see on a form response. Once any answer is marked `sharedWithEnduser`
 * (a form field's portal-sharing checkbox, or the Healthie "visible in portal" question list applied
 * at chart-note import), only the shared answers are shown; otherwise every answer is.
 */
export const getEnduserVisibleResponses = (responses: FormResponseValue[] | undefined): FormResponseValue[] => {
  if (!responses) return [];
  const anyShared = responses.some((response) => response.sharedWithEnduser === true);
  return anyShared ? responses.filter((response) => response.sharedWithEnduser === true) : responses;
};
